export default __webpack_public_path__ + "static/logo-keli-5c93b755fe44a6a8ec26370f92bd61a4.png";